
import { Notification } from "interfaces/notification"
import { NotificationType } from "../action-types/notificationTypes"
import { Action } from "../actions/notificationActions"

const initialState: Notification[] = [
    {
        id: "1",
        name: "Teste 1",
        read: true,
        sent_at: new Date()
    },
    {
        id: "2",
        name: "Teste 2",
        read: false,
        sent_at: new Date()
    },
    {
        id: "3",
        name: "Teste 3",
        read: false,
        sent_at: new Date()
    },
    {
        id: "4",
        name: "Teste 4",
        read: false,
        sent_at: new Date()
    },
]
const reducer = (state: Notification[] = initialState, action: Action) => {
    switch (action.type) {
        case NotificationType.LIST:
            return action.payload
        case NotificationType.ADD:
            return [...state, action.payload]
        case NotificationType.READ:
            return state.map(st => {
                if(st.id === action.payload) st.read = true
                return st
            })
        case NotificationType.READ_ALL:
            return state.map(st => {
                if(!st.read) st.read = true
                return st
            })
        default:
            return state
    }
}

export default reducer